// extracted by mini-css-extract-plugin
export var stepActive = "_2p-3";
export var stepCompleted = "_2p-4";
export var stepConnectorLine = "_2p-b";
export var stepIndicatorCircle = "_2p-6";
export var stepIndicatorCircleCompleted = "_2p-7";
export var stepIndicatorCircleDefault = "_2p-8";
export var stepIndicatorTextCompleted = "_2p-9";
export var stepIndicatorTextDefault = "_2p-a";
export var stepPending = "_2p-5";
export var wizardContainer = "_2p-1";
export var wizardContent = "_2p-2";
export var wizardModal = "_2p-0";